import { CharacterResult } from "common/character/dto/CharacterResult";
import styled from "styled-components";
import { Divider } from "@mui/material";
import RelateAnswerLetter from "./relate_answer/RelateAnswerLetter";

type RelatePlayCharItemProps = {
  character: CharacterResult;
};

const RelatePlayCharItem = ({ character }: RelatePlayCharItemProps) => {
  return (
    <CharacterDiv>
      <Divider />
      <Div>
        <RelateAnswerLetter letter={character.letter} />
      </Div>
    </CharacterDiv>
  );
};

const CharacterDiv = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

const Div = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
`;

export default RelatePlayCharItem;
